<div class="mobile-menu" *ngIf="menuExist">
  <cdk-virtual-scroll-viewport orientation="horizontal" itemSize="50">
    <ng-container *cdkVirtualFor="let item of menuItems">
      <ui-tab [item]="item"></ui-tab>
    </ng-container>
  </cdk-virtual-scroll-viewport>
</div>
